const Config: any = {
  BaseUrlDev: process.env.REACT_APP_API_URL_DEV,
  BaseUrlProd: process.env.REACT_APP_API_URL_PROD,
  ApiKey: process.env.REACT_APP_X_API_KEY,
  BaseUrlPickupStudentDev: process.env.REACT_APP_PICKUP_STUDENT_DEV,
  BaseUrlPickupStudentProd: process.env.REACT_APP_PICKUP_STUDENT_PROD,
  BaseUrlAttendanceProDev: process.env.REACT_APP_ATTENDANCE_PRO_DEV,
  BaseUrlAttendanceProProd: process.env.REACT_APP_ATTENDANCE_PRO_PROD,
  BaseUrlRecitationDev: process.env.REACT_APP_RECITATION_DEV,
  BaseUrlRecitationPro: process.env.REACT_APP_RECITATION_DEV,
  BaseUrlPerizinanDev: process.env.REACT_APP_PERIZINAN_DEV,
  BaseUrlPerizinanProd: process.env.REACT_APP_PERIZINAN_PROD,
  BaseUrlViolationPointDev: process.env.REACT_APP_VIOLATION_POINT_DEV,
  BaseUrlViolationPointProd: process.env.REACT_APP_VIOLATION_POINT_PROD,
  BaseUrlMedicalRecordDev: process.env.REACT_APP_MEDICAL_RECORD_DEV,
  BaseUrlMedicalRecordPro: process.env.REACT_APP_MEDICAL_RECORD_DEV
};
let baseUrl = "";
export const check = () => {
  if (process.env.NODE_ENV == "production") {
    baseUrl = Config.BaseUrlProd;

    // remove consoles in production
    console.log = () => { };
    console.debug = () => { };
    console.info = () => { };
    console.warn = () => { };
  } else {
    baseUrl = Config.BaseUrlDev;
  }
  return baseUrl;
};
export default Config;
